import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { endpoints } from 'Core/defaultValues';
import { HasPermission } from "Core/security"
import { useNavigate } from "react-router-dom";


const url = `${endpoints.FIELD_SYNC}/gpst?ssoaccesstoken=${localStorage.getItem('IdToken')}`
let isLoad = false


const FieldSyncView = () => {
  const fieldSyncRef = useRef();
  const navigate = useNavigate()
  const { refreshTokenResult, user } = useSelector((state) => state.securityRedux);

  const validatePermission =  HasPermission(user, "fldsync", [263])
  if(!validatePermission){
    navigate('app/')
  }

  useEffect(() => {
    if (refreshTokenResult && isLoad) {
      const newToken = localStorage.getItem('IdToken')
      if (fieldSyncRef?.current) {
        fieldSyncRef?.current?.contentWindow.postMessage({
          "idToken": newToken
        }, url);
      }
    }
  }, [refreshTokenResult]);


  useEffect(() => {
		window.addEventListener("message", eventMessages, false);
		//GerVersionFromServer()

		//component unmount
		return () => {
			//props.setToggleFullScreen(false)
			window.removeEventListener("message", eventMessages, false);
		}
	})

  const eventMessages = (event) => {
		// console.log('event', event)
	}

  return (
    <div style={{ height: "98vh" }}>
      <iframe
        id="fieldSync"
        ref={fieldSyncRef}
        title="Field Sync"
        width="100%"
        height="100%"
        src={url}
        onLoad={() => {
          isLoad = true
        }}
      ></iframe>
    </div>
  );
};

export default FieldSyncView;
